import React, { useState, useEffect } from 'react';
import { ShieldCheck, Check } from 'lucide-react';
import { templateService } from '../services';
import { Dialog, Badge, Button } from './ds';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

const TemplatePicker = ({ onSelect, onCancel }) => {
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected]   = useState(null);
  const [loading, setLoading]     = useState(true);

  useEffect(() => {
    templateService.getTemplates().then(res => {
      setTemplates(res.data);
      setSelected(res.data[0]?.id || null);
    }).finally(() => setLoading(false));
  }, []);

  return (
    <Dialog
      open
      onClose={onCancel}
      title="Framework auswählen"
      description="Wählen Sie das Assessment-Framework für dieses Projekt."
      width={580}
      footer={
        <>
          <Button variant="secondary" size="md" onClick={onCancel}>Abbrechen</Button>
          <Button
            size="md"
            disabled={!selected}
            onClick={() => onSelect(templates.find(t => t.id === selected))}
            trailingIcon={<span>→</span>}
          >Weiter</Button>
        </>
      }
      style={{ maxHeight: '85vh', display: 'flex', flexDirection: 'column' }}
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px 0', color: '#8A93A3', fontSize: 14, fontFamily: FONT }}>
          Frameworks werden geladen…
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12, overflowY: 'auto' }}>
          {templates.map(tpl => {
            const sel = selected === tpl.id;
            return (
              <button
                key={tpl.id}
                onClick={() => setSelected(tpl.id)}
                style={{
                  textAlign: 'left', fontFamily: FONT,
                  border: `2px solid ${sel ? '#1E4FBE' : '#D7DCE4'}`,
                  borderRadius: 12, padding: '20px 22px',
                  cursor: 'pointer',
                  background: sel ? '#F2F6FE' : '#F5F7FA',
                  transition: 'all 120ms',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                  <div style={{
                    width: 36, height: 36, borderRadius: 10, flexShrink: 0,
                    background: sel ? '#CBD9F9' : '#EBEEF3', color: sel ? '#1B4098' : '#667085',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                  }}>
                    <ShieldCheck width={18} height={18} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <span style={{ fontWeight: 700, fontSize: 14, color: '#101623' }}>
                      {tpl.name}
                    </span>
                    {tpl.standard && (
                      <span style={{ marginLeft: 8 }}>
                        <Badge tone="info">{tpl.standard}</Badge>
                      </span>
                    )}
                  </div>
                  {sel && (
                    <div style={{
                      width: 20, height: 20, borderRadius: '50%',
                      background: '#1E4FBE',
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0,
                    }}>
                      <Check width={11} height={11} color="#fff" strokeWidth={3} />
                    </div>
                  )}
                </div>
                <p style={{ margin: '0 0 12px', color: '#475569', fontSize: 13, lineHeight: 1.55 }}>
                  {tpl.description}
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                  {tpl.categories.slice(0, 5).map(cat => (
                    <span key={cat} style={{
                      padding: '3px 8px', borderRadius: 999,
                      background: sel ? '#CBD9F9' : '#EBEEF3',
                      color: sel ? '#1B4098' : '#667085',
                      fontSize: 11,
                    }}>{cat}</span>
                  ))}
                  {tpl.categories.length > 5 && (
                    <span style={{ fontSize: 11, color: '#8A93A3', padding: '3px 4px' }}>
                      +{tpl.categories.length - 5} weitere
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </Dialog>
  );
};

export default TemplatePicker;
